import http from '@/communication/AuthConnection'

export default async ({ commit, state }, { list }) => {
  const payload = {
    list
  }

  try {
    const result = await http.post(
      `/v1/rms/merge-in-pdf`,
      payload,
      {
        responseType: 'arraybuffer',
        encoding: null
      })

    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/rms/MergeRmsFromList.js